import { OrganizationEventsForBookingData } from "../../models/organizationEventsForBookingData";
import { BaseCrudService } from "../baseCrudService";
import apiRoutes from "../apiRoutes";

/**
 * The organization events for booking service
 */
export class OrganizationEventsForBookingService extends BaseCrudService {
  /**
   * Fetches the organization events data
   * @returns {Promise<OrganizationEventsForBookingData[]>}
   */
  async getEventForBookingsByOrganization(): Promise<
    OrganizationEventsForBookingData[]
  > {
    const response = await this.getAll<OrganizationEventsForBookingData[]>(
      apiRoutes.events_organization_booking
    );
    return response.data;
  }
}
